@use "variables" as *;

.message {
  white-space: pre-wrap;
  word-break: break-word;
  font-size: $fontSize-m;
  margin-bottom: $spacing-m;
}

.button {
  font-size: $fontSize-m;
}

.imageAttachment {
  width: 100%;
}
